import useBroker from '../../components/CustomHooks/useBroker';
import useBrokerEstates from '~js/React/components/CustomHooks/useBrokerEstates';
import { FC, lazy, Suspense, useContext } from 'react';
const BrokerReviews = lazy(() => import('./BrokerReviews'));
import { OfficePageContext } from '../Context/OfficePageContext';
import { BoneoImageBroker } from '~js/React/components/ObjectPageComponents/BoneoImageBroker';
const ContactForm = lazy(() => import('~js/React/forms/ContactForm'));
const BrokerObjects = lazy(() => import('./BrokerObjects'));
const BrokerSoldObjects = lazy(() => import('./BrokerSoldObjects'));
const BlockList = lazy(() => import('../../components/Blocks/BlockList'));

type Props = {
  brokerQuery: string;
};

const BrokerProfilePageNew: FC<Props> = ({ brokerQuery }) => {
  const { officeAdminPage, office } = useContext(OfficePageContext);
  const isCommercial = office?.properties?.isCommercial;
  const officeId = office?.properties?.officeId;
  const { data: broker } = useBroker(brokerQuery, officeId);

  const { data: brokerSoldObjects, isLoading } = useBrokerEstates(
    broker?.id,
    false,
    false,
    true
  );

  const { data: allBrokerEstatesForSale } = useBrokerEstates(
    broker?.id,
    true,
    true,
    false
  );

  return (
    <>
      {broker?.reviews && broker?.reviews.length > 0 && (
        <Suspense>
          <BrokerReviews broker={broker} />
        </Suspense>
      )}

      {broker?.hasEstates &&
        allBrokerEstatesForSale &&
        allBrokerEstatesForSale?.totalLength > 0 &&
        broker?.id && (
          <Suspense>
            <BrokerObjects
              brokerId={broker?.id}
              allBrokerEstatesForSale={allBrokerEstatesForSale?.totalLength}
            />
          </Suspense>
        )}

      {brokerSoldObjects && brokerSoldObjects?.totalLength ? (
        <Suspense>
          <BrokerSoldObjects
            brokerId={broker?.id}
            brokerEstateInfo={brokerSoldObjects}
            isLoading={isLoading}
          />
        </Suspense>
      ) : null}

      {officeAdminPage?.properties?.showFormBroker && broker && (
        <Suspense>
          <ContactForm
            officeAdminPage={officeAdminPage}
            office={office}
            broker={broker}
            isBrokerForm
          />
        </Suspense>
      )}

      {officeAdminPage?.properties?.brokerBlockList?.items && (
        <Suspense>
          <BlockList
            blocks={officeAdminPage?.properties?.brokerBlockList?.items}
          />
        </Suspense>
      )}

      {!isCommercial && (
        <Suspense>
          <div className="mx-auto max-w-container">
            <BoneoImageBroker />
          </div>
        </Suspense>
      )}
    </>
  );
};

export default BrokerProfilePageNew;
